/**
 * Home (메인/문서/컴포넌트 쇼케이스 등) – PHP HomeController 와 액션명 동기화.
 */
import { Logger } from "../../utils/Logger";
import { ContactFormController } from "../components/ContactForm";
import { QuillEditor } from "../../components/QuillEditor";

export const HomeController = {
  contact(): void {
    Logger.info("HomeController.contact");
    ContactFormController.form();
  },

  components(): void {
    Logger.info("HomeController.components");
    const csrf =
      (document.querySelector('input[name="_token"]') as HTMLInputElement | null)?.value ??
      (document.querySelector('meta[name="csrf-token"]') as HTMLMetaElement | null)?.content ??
      "";
    const editorEl = document.getElementById("components-content-editor");
    const thumbWrap = document.getElementById("components-thumb-upload");
    const uploadUrl = thumbWrap?.getAttribute("data-upload-url") ?? "";

    if (editorEl && uploadUrl && csrf) {
      const placeholder = editorEl.getAttribute("data-placeholder") ?? "";
      const quill = new QuillEditor(editorEl, {
        placeholder,
        upload: { uploadUrl, csrf, fileKey: "file" },
      });
      quill.init();
    } else if (editorEl) {
      const placeholder = editorEl.getAttribute("data-placeholder") ?? "";
      const quill = new QuillEditor(editorEl, { placeholder });
      quill.init();
    }

    const thumbDrop = document.getElementById("components-thumb-dropzone");
    const thumbInput = document.getElementById("components-thumb-input") as HTMLInputElement | null;
    const thumbPreview = document.getElementById("components-thumb-preview");
    if (uploadUrl && thumbInput && thumbDrop && thumbPreview && csrf) {
      const uploadThumb = (file: File): void => {
        const fd = new FormData();
        fd.append("file", file);
        fd.append("_token", csrf);
        fd.append("category", "image");
        fd.append("target_type", "post");
        fd.append("target_id", "0");
        fetch(uploadUrl, {
          method: "POST",
          body: fd,
          headers: { "X-Requested-With": "XMLHttpRequest", Accept: "application/json" },
        })
          .then((r) => r.json())
          .then((json: Record<string, unknown>) => {
            const data = json?.data as Record<string, unknown> | undefined;
            if (json?.result === "success" && data?.file_url) {
              thumbPreview.innerHTML =
                '<img src="' +
                String(data.file_url).replace(/"/g, "&quot;") +
                '" alt="" style="max-width:200px;height:auto;border-radius:4px;">';
            } else {
              alert((json?.msg as string) || "업로드 실패");
            }
          })
          .catch(() => alert("업로드 중 오류"));
      };
      thumbDrop.addEventListener("click", () => thumbInput.click());
      thumbInput.addEventListener("change", () => {
        const file = thumbInput.files?.[0];
        thumbInput.value = "";
        if (file?.type?.startsWith("image/")) uploadThumb(file);
      });
    }
  },
};
